import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';

@Injectable()
export class GeoLocationStoreEffects {
  constructor(private actions$: Actions) {}
}
